import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { StartAndEndDateField } from "V2.0/HomePages/Downloads/components/StartAndEndDateField";
import InputComponent from "V2.0/components/InputComponent";
import { useAssistants } from "V2.0/HomePages/Assistants";
import { useAllAssistantOptions } from "V2.0/HomePages/HomeCampaign/useAllAssistantOptions";
import { useEffect } from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import { useAssistant } from "V2.0/HomePages/Assistants/Assistant";
import ExtractedDataFilters from "./ExtractedDataFilters";
import TagsFilters from "./TagsFilter";

function ConversationFilters(props) {
  const {
    startDate,
    endDate,
    updateDate,
    assistantId,
    updateAssistantId,
    extractedData,
    updateExtractedData,
    callDuration,
    updateCallDuration,
    assignedTags,
    updateAssignedTags,
    untagged,
    updateUntagged,
    resetFilters,
    onClose,
    onApplyFilters,
    workspaceId,
    assistants,
    workspaceTags,
  } = props;

  const { assistant, fetchAssistant } = useAssistant(assistantId, workspaceId);

  useEffect(() => {
    if (assistantId && workspaceId) {
      fetchAssistant();
    }
  }, [assistantId, workspaceId]);

  const isFilterApplied =
    Boolean(startDate) ||
    Boolean(endDate) ||
    Boolean(assistantId) ||
    Boolean(Object.keys(extractedData).length) ||
    assignedTags.length > 0 ||
    untagged ||
    Number(callDuration) > 0;

  const assistantOptions = [
    { id: 0, label: "(Select Assistant)", value: "" },
    ...assistants.map((assistant, id) => {
      return { id: id + 1, label: assistant.name, value: assistant._id };
    }),
  ];

  function handleApplyFilters() {
    onApplyFilters();
    onClose();
  }

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Filters</DialogTitle>
      <DialogBody>
        <div className="flex flex-col items-start gap-y-8">
          <div className="flex flex-col w-full items-start gap-y-2">
            <p className="text-sm font-semibold text-gray-500">Date Range:</p>
            <StartAndEndDateField
              hideLabel={true}
              error=""
              date={[Number(startDate), Number(endDate)]}
              setError={() => {}}
              setDate={updateDate}
            />
          </div>
          <div className="flex flex-col w-full  items-start gap-y-2">
            <p className="text-sm font-semibold text-gray-500">
              Minimum Call Duration (seconds):
            </p>
            <div className="w-full">
              <InputComponent
                type="number"
                value={callDuration}
                min={0}
                onChange={(e) => updateCallDuration(e.target.value)}
              />
            </div>
          </div>
          <div className="flex flex-col w-full  items-start gap-y-4">
            <p className="text-sm font-semibold text-gray-500">Tags:</p>
            <div className="w-full">
              <TagsFilters
                tags={workspaceTags}
                untagged={untagged}
                assignedTags={assignedTags}
                updateUntagged={updateUntagged}
                updateAssignedTags={updateAssignedTags}
              />
            </div>
          </div>

          <div className="flex flex-col w-full  items-start gap-y-2">
            <p className="text-sm font-semibold text-gray-500">Assistant:</p>
            <div className="w-full">
              <InputComponent
                type="select"
                options={assistantOptions}
                value={assistantId}
                onChange={(e) => updateAssistantId(e.target.value)}
              />
            </div>
          </div>
          {assistantId &&
            assistant?.extraction?.extractionParameters.length > 0 && (
              <div className="flex flex-col w-full  items-start gap-y-2">
                <p className="text-sm font-semibold text-gray-500">
                  Extracted Data:
                </p>
                <div className="w-full">
                  <ExtractedDataFilters
                    extraction={
                      assistant?.extraction || { extractionParameters: [] }
                    }
                    extractedData={extractedData}
                    updateExtractedData={updateExtractedData}
                  />
                </div>
              </div>
            )}
        </div>
      </DialogBody>
      <DialogActions>
        {isFilterApplied ? (
          <Button
            outline
            onClick={resetFilters}
          >
            Reset Filters
          </Button>
        ) : (
          <Button
            outline
            onClick={onClose}
          >
            Cancel
          </Button>
        )}
        <Button
          disabled={!isFilterApplied}
          onClick={handleApplyFilters}
        >
          Apply Filters
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConversationFilters;
